module.exports = __webpack_public_path__ + "img/bear3.5420c78f.png";